var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.topState&&!_vm.isMobile())?_c('div',{staticClass:"top-box"},[_c('div',{staticClass:"top",on:{"click":_vm.goTop}},[_c('img',{staticClass:"top-img",attrs:{"src":require("../../static/img/go_top.png"),"alt":"图片"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }